export const ADD_TO_CART = 'ADD_TO_CART';
export const REMOVE_ITEM = 'REMOVE_ITEM';
export const SELECT_ITEM = 'SELECT_ITEM';
export const SELECT_SIZE = 'SELECT_SIZE';
export const REMOVE_SELECT = 'REMOVE_SELECT';